module.exports = __webpack_public_path__ + "static/ohagwu-c983ac9dd90112b61d718b59b8a61ab4.png";